//----- Component --------------------------------------------------------/
// Developer :  Guillermo Sedran
// Creation Date : 04/11/2025
// Version : 1
// Description : Listado de repartos de grúas + Menú para asignarlos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  TextField,
  Grid,
  Dialog,
  Box,
  Stack,
  Typography,
  Button,
  DialogContent,
  Tooltip,
  Chip,
  Autocomplete,
  Paper,
  InputAdornment,
  IconButton,
  DialogTitle,
  DialogActions,
  Card,
  CardContent,
} from "@mui/material";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { UrlApi } from "../../../../services/apirest";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import ModalVencimientos from "./ModalVencimientos";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Notify from "../../../Notify";
import { getData, postData, putData } from "../../../../services/library";
import { MRT_TablePagination } from "material-react-table";
import ModalEditar from "./ModalEditar";
import MapaRepartos from "../MapaRepartos";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import {
  LocalShipping,
  Event,
  WarningAmber,
  ArrowBack,
  Check,
  Info,
  Close,
  Assignment,
  SwapHoriz,
} from "@mui/icons-material";

import EventIcon from "@mui/icons-material/Event";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CrearRepartos2(props) {
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // Estados para el diálogo de confirmación de guardado
  const [openDialogConfirmacion, setOpenDialogConfirmacion] = useState(false);
  const [datosConfirmacion, setDatosConfirmacion] = useState(null);

  const [fechaseleccionada, setFechaSeleccionada] = useState("");
  const [modalVencimientos, setmodalVencimientos] = useState(false);
  const [viajesAsignados, setViajesAsignados] = useState();

  // NUEVO
  const [gruaSeleccionada, setGruaSeleccionada] = useState(
    props.gruaSeleccionada,
  );

  const globalTheme = useTheme();
  const [rowSelection, setRowSelection] = useState({});
  const [datos, setDatos] = useState({});
  const [modalEdit, setmodalEdit] = useState(false);
  const [openMapa, setOpenMapa] = useState(false);

  const [openModalMoverGrua, setOpenModalMoverGrua] = useState(false);
  const [reclamoParaMover, setReclamoParaMover] = useState(null);
  const [gruaDestino, setGruaDestino] = useState(null);

  const tableRef = useRef(null);

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const obtenerViajesAsignados = () => {
    getData(
      "/viajes_gruas/asignados/grua/" + props.gruaSeleccionada.id_vehiculo,
      setViajesAsignados,
    );
  };

  const [gruas, setGruas] = useState([]);

  const obtenerGruas = () => {
    fetch(UrlApi + "/vehiculos/gruas")
      .then((data) => data.json())
      .then((data) => setGruas(data));
  };

  useEffect(() => {
    obtenerGruas();
  }, []);

  // AGREGAR PARA VER LOS VENCIMIENTOS DE LOS COMPONENTES
  const [vencimientosGrua, setVencimientosGrua] = useState([]);

  const obtenerVencimientosGrua = () => {
    fetch(UrlApi + "/vehiculos_vencimientos/id/" + gruaSeleccionada.id_vehiculo)
      .then((data) => data.json())
      .then((data) => setVencimientosGrua(data));
  };

  useEffect(() => {
    obtenerVencimientosGrua();
  }, [gruaSeleccionada]); // Se ejecuta al inicio y cuando cambia la grúa

  // --------------------------------------------------------------

  const [disBtn, setDisBtn] = useState(true);

  const tieneReclamoSeleccionado = Boolean(
    rowSelection && Object.keys(rowSelection).length > 0,
  );

  useEffect(() => {
    const tieneFechaValida =
      fechaseleccionada && fechaseleccionada.trim() !== "";

    const tieneComponentesVencidos =
      Array.isArray(vencimientosGrua) &&
      vencimientosGrua.some((item) => diasRestantes(item.vencimiento) < 0);

    setDisBtn(
      !tieneFechaValida ||
        tieneComponentesVencidos ||
        !tieneReclamoSeleccionado,
    );
  }, [fechaseleccionada, vencimientosGrua, rowSelection]);

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  const handleUbicacion = (linea) => {
    setOpenMapa(true);
    setDatos(linea);
  };

  // ── MOVER A OTRA GRÚA ─────────────────────────────────────────────────────────────────
  const handleAbrirMoverGrua = (rowData) => {
    setReclamoParaMover(rowData);
    setGruaDestino(null);
    setOpenModalMoverGrua(true);
  };

  const handleConfirmarMoverGrua = async () => {
    if (!gruaDestino || !reclamoParaMover) return;
    try {
      const response = await fetch(
        `${UrlApi}/reclamos/update_2/${reclamoParaMover.id_reclamo}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ grua_asignada: gruaDestino.id_vehiculo  }),
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje(
        `Reclamo #${reclamoParaMover.id_reclamo} movido a grúa ${gruaDestino.patente}`,
      );
      await obtenerViajesAsignados();
    } catch (err) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error al mover el reclamo: " + err.message);
    } finally {
      setOpenModalMoverGrua(false);
      setReclamoParaMover(null);
      setGruaDestino(null);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    obtenerViajesAsignados();
    obtenerGruas();
  }, []);

  const handleClose = () => {
    props.setOpen(false);
    props.setMostrarPedidos(true);
    props.actualizar();
  };

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  // Función para obtener el UUID de un viaje existente para un vehículo y fecha
  const obtenerUuidExistente = async (idGrua, fecha) => {
    try {
      // Formatear la fecha a YYYY-MM-DD
      const fechaFormateada = new Date(fecha).toISOString().split("T")[0];

      const response = await fetch(
        `${UrlApi}/viajes_gruas/viaje_existente/id_grua/${idGrua}/fecha_salida/${fechaFormateada}`,
      );

      if (!response.ok) {
        console.warn(
          `No se pudo verificar UUID existente. Status: ${response.status}`,
        );
        return null; // Si falla, retorna null para generar nuevo UUID
      }

      const data = await response.json();

      // Verificar si existe un viaje para esa fecha y vehículo
      if (data && data.existe && data.uuid_viaje) {
        return {
          uuid_viaje: data.uuid_viaje,
          estado: data.estado,
        };
      }

      return null;
    } catch (error) {
      console.error("Error al obtener UUID existente:", error);
      // En caso de error, retornamos null para generar un nuevo UUID
      return null;
    }
  };

  // Función para guardar
  const guardarViaje = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    // obtener keys seleccionadas
    const keys = Object.keys(rowSelection || {}).filter((k) => rowSelection[k]);
    if (!keys.length) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("No seleccionaste ningún reclamo para actualizar.");
      setDisBtn(false);
      return;
    }

    // construir selectedRows a partir de índices
    const selectedRows = keys
      .map((k) => {
        const idx = Number(k);
        return Number.isInteger(idx) && viajesAsignados[idx]
          ? viajesAsignados[idx]
          : null;
      })
      .filter(Boolean);

    if (!selectedRows.length) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("No se pudieron resolver las filas seleccionadas.");
      setDisBtn(false);
      return;
    }

    // Chequear fecha y grua
    if (!fechaseleccionada) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Seleccioná una fecha de salida válida.");
      setDisBtn(false);
      return;
    }
    const idGrua =
      gruaSeleccionada?.id ?? gruaSeleccionada?.id_vehiculo ?? null;
    if (!idGrua) {
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Seleccioná una grúa válida.");
      setDisBtn(false);
      return;
    }

    try {
      // Verificar si ya existe un viaje para este vehículo y fecha
      let uuidViaje;
      let esViajeExistente = false;

      // Primero, verificar si ya existe un viaje para esta grúa y fecha
      const viajeExistente = await obtenerUuidExistente(
        idGrua,
        fechaseleccionada,
      );

      if (viajeExistente) {
        // Si ya existe un viaje, verificar si está finalizado (estado 345)
        if (viajeExistente.estado === 345) {
          // Viaje está finalizado, informar y no permitir guardar
          setOpenSnack(true);
          setColorMensaje("#F1948A");
          setMensaje(
            "No se puede agregar reclamos a un viaje que ya está finalizado.",
          );
          setDisBtn(false);
          return;
        } else {
          // Si ya existe un viaje pero NO está finalizado, preguntar al usuario si desea agregar al viaje existente
          setDatosConfirmacion({
            uuidExistente: viajeExistente.uuid_viaje,
            selectedRows,
            idGrua,
            fechaseleccionada,
            gruaPatente: gruaSeleccionada?.patente,
            cantidadReclamos: selectedRows.length,
          });
          setOpenDialogConfirmacion(true);
          setDisBtn(false);
          return;
        }
      } else {
        // Si no existe UUID_viaje para ese día se genera uno nuevo
        uuidViaje = uuidv4();
        esViajeExistente = false;
        await realizarGuardado(
          selectedRows,
          idGrua,
          fechaseleccionada,
          uuidViaje,
          esViajeExistente,
        );
      }
    } catch (err) {
      console.error("Error en try/catch:", err);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error en la solicitud: " + err.message);
      setDisBtn(false);
    }
  };

  // "POST" en "viajes_gruas"
  const realizarGuardado = async (
    selectedRows,
    idGrua,
    fechaseleccionada,
    uuidViaje,
    esViajeExistente,
  ) => {
    setDisBtn(true);

    try {
      // Crear todas las promesas
      const promises = [];

      // Solo crear viajes_gruas si NO es un viaje existente
      if (!esViajeExistente) {
        // Para cada reclamo, crear un registro en viajes_gruas
        selectedRows.forEach((reclamo) => {
          // El ID del reclamo es id_reclamo
          const idReclamo = reclamo.id_reclamo;

          if (!idReclamo) {
            console.warn("Reclamo sin ID válido para viajes_gruas:", reclamo);
            return;
          }

          // 1. Promesa para CREAR nuevo registro en viajes_gruas (POST) - solo si es viaje NUEVO
          const payloadViajesGruas = {
            id_grua: idGrua,
            estado: 343, // estado por defecto al crearse
            fecha_programada_viaje: fechaseleccionada,
            uuid_viaje: uuidViaje,
          };

          const promesaViajesGruas = fetch(`${UrlApi}/viajes_gruas`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payloadViajesGruas),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json().then((data) => ({
                ok: true,
                table: "viajes_gruas",
                idReclamo,
                data,
              }));
            })
            .catch((err) => {
              console.error(
                "Fetch error para viajes_gruas POST",
                idReclamo,
                err,
              );
              return {
                ok: false,
                error: err.message,
                table: "viajes_gruas",
                idReclamo,
              };
            });

          promises.push(promesaViajesGruas);
        });
      }

      // Para cada reclamo, actualizar la tabla reclamos (esto se hace tanto para viaje nuevo como existente)
      selectedRows.forEach((reclamo) => {
        // ID del reclamo para tabla reclamos
        const idReclamoTabla = reclamo.id_reclamo;

        if (!idReclamoTabla) {
          console.warn("Reclamo sin ID válido para reclamos:", reclamo);
          promises.push(
            Promise.resolve({
              ok: false,
              reason: "no-id",
              table: "reclamos",
              reclamo,
            }),
          );
          return;
        }

        // 2. Promesa para actualizar tabla reclamos (PUT) - para ambos casos
        const payloadReclamos = {
          uuid_viaje: uuidViaje,
          estado_viaje: 343,
        };

        const promesaReclamos = fetch(`${UrlApi}/reclamos/${idReclamoTabla}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payloadReclamos),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json().then((data) => ({
              ok: true,
              table: "reclamos",
              idReclamoTabla,
              data,
            }));
          })
          .catch((err) => {
            console.error("Fetch error para reclamos id", idReclamoTabla, err);
            return {
              ok: false,
              error: err.message,
              table: "reclamos",
              idReclamoTabla,
            };
          });

        promises.push(promesaReclamos);
      });

      const results = await Promise.all(promises);

      // Separar resultados por tabla
      const resultsViajesGruas = results.filter(
        (r) => r.table === "viajes_gruas",
      );
      const resultsReclamos = results.filter((r) => r.table === "reclamos");

      const failedViajesGruas = resultsViajesGruas.filter((r) => !r.ok);
      const failedReclamos = resultsReclamos.filter((r) => !r.ok);

      if (failedViajesGruas.length === 0 && failedReclamos.length === 0) {
        setOpenSnack(true);
        setColorMensaje("#D4EFDF");

        // Mensaje diferente dependiendo si es un viaje nuevo o existente
        if (esViajeExistente) {
          setMensaje(
            `¡Éxito! ${selectedRows.length} reclamo(s) agregado(s) al viaje existente`,
          );
        } else {
          setMensaje(
            `¡Éxito! Viaje nuevo creado. ${selectedRows.length} reclamo(s) asignado(s).`,
          );
        }

        await obtenerViajesAsignados(); // ACTUALIZAR DATOS
      } else {
        setOpenSnack(true);
        setColorMensaje("#F1948A");

        let mensajeError = `Error en la operación: `;
        if (failedViajesGruas.length > 0) {
          mensajeError += `${failedViajesGruas.length} creaciones en viajes_gruas fallaron. `;
        }
        if (failedReclamos.length > 0) {
          mensajeError += `${failedReclamos.length} actualizaciones en reclamos fallaron. `;
        }

        // Agregar información del UUID usado
        mensajeError += esViajeExistente
          ? `(Se intentó agregar al viaje existente UUID: ${uuidViaje})`
          : `(Se intentó crear nuevo viaje UUID: ${uuidViaje})`;

        setMensaje(mensajeError);
        console.error("Responses no OK / errores:", [
          ...failedViajesGruas,
          ...failedReclamos,
        ]);
      }
    } catch (err) {
      console.error("Error en try/catch:", err);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje("Error en la solicitud: " + err.message);
    } finally {
      setDisBtn(false);
      setRowSelection({});
    }
  };

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  // Función para manejar la confirmación de agregar a viaje existente
  const handleConfirmarAgregarViaje = async () => {
    if (!datosConfirmacion) return;

    const { uuidExistente, selectedRows, idGrua, fechaseleccionada } =
      datosConfirmacion;

    try {
      await realizarGuardado(
        selectedRows,
        idGrua,
        fechaseleccionada,
        uuidExistente,
        true, // esViajeExistente = true
      );
    } catch (err) {
      console.error("Error al agregar a viaje existente:", err);
      setOpenSnack(true);
      setColorMensaje("#F1948A");
      setMensaje(
        "Error al agregar reclamos al viaje existente: " + err.message,
      );
    } finally {
      setOpenDialogConfirmacion(false);
      setDatosConfirmacion(null);
      setRowSelection({});
    }
  };

  // Función para cancelar la operación
  const handleCancelarAgregarViaje = () => {
    setOpenDialogConfirmacion(false);
    setDatosConfirmacion(null);
    setDisBtn(false); // Reactivar botón
    setRowSelection({}); // Limpiar selección
  };

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id_reclamo", size: 70 },
      {
        header: "Cliente",
        accessorKey: "cliente_razon_social",
        enableEditing: false,
        size: 70,
        Cell: ({ cell }) => (
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {cell.getValue()}
          </div>
        ),
      },
      { header: "Localidad", accessorKey: "localidad", size: 70 },
      {
        header: "Dir.Entrega",
        accessorKey: "direccion_entrega",
        size: 100,
        Cell: ({ cell }) => (
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {cell.getValue()}
          </div>
        ),
      },
      {
        header: "Inicio",
        accessorKey: "reporte_fecha_abierto",
        size: 60,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value) return "-";
          const fecha = new Date(value);
          return fecha.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        },
      },
      {
        header: "Estado",
        accessorKey: "estado_viaje",
        size: 50,
        enableHiding: false,
      },
      {
        header: "Detalle",
        accessorKey: "detalle_reclamo",
        size: 100,
        Cell: ({ cell }) => (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {cell.getValue()}
          </div>
        ),
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1.2rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "1.1rem",
              },
            },
          },
        },
      }),
    [globalTheme],
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 50 },
    columnVisibility: { estado_viaje: false },
  };

  // ---------------------------------------------------

  const ahora = new Date();

  function diasRestantes(fechaISO) {
    const fecha = new Date(fechaISO);
    // diferencia en ms -> días (redondeo hacia abajo)
    const diffMs =
      fecha.setHours(0, 0, 0, 0) - new Date(ahora).setHours(0, 0, 0, 0);
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }

  // ---------------------------------------------------

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  return (
    <>
      {viajesAsignados && (
        <>
          <Grid
            container
            spacing={2}
            paddingTop={2}
            paddingLeft={2}
            paddingRight={2}
          >
            {/* Botones + Selectores */}
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                {/* Botón Volver */}
                <Grid item xs={6} sm={3} md={2}>
                  <Button
                    fullWidth
                    onClick={handleClose}
                    variant="contained"
                    color="error"
                    size="large"
                    startIcon={<ArrowBack />}
                    sx={{
                      borderRadius: 2,
                      borderWidth: 2,
                      "&:hover": { borderWidth: 2 },
                    }}
                  >
                    Volver
                  </Button>
                </Grid>

                {/* Selector de Grúa */}
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    disableClearable
                    options={gruas || []}
                    value={gruaSeleccionada || null}
                    onChange={(event, newValue) =>
                      setGruaSeleccionada(newValue)
                    }
                    getOptionLabel={(option) => `${option.patente}`}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "white",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        "&:hover": { boxShadow: "0 4px 8px rgba(0,0,0,0.15)" },
                        "&.Mui-focused": {
                          boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Grúa"
                        placeholder="Seleccione una grúa"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <LocalShipping
                                sx={{
                                  color: "primary.main",
                                  mr: 1,
                                  fontSize: "1.4rem",
                                }}
                              />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} sx={{ py: 1.5 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <LocalShipping
                            sx={{ color: "primary.main", mr: 2 }}
                          />
                          <Box>
                            <Typography variant="body1" fontWeight="600">
                              {option.patente}
                              {option.chofer ? ` - ${option.chofer}` : ""}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  />
                </Grid>

                {/* Selector de Fecha */}
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    required
                    label="Fecha de Salida"
                    variant="outlined"
                    size="small"
                    name="fecha_salida_reparto"
                    value={moment(fechaseleccionada).format("YYYY-MM-DD")}
                    onChange={(e) => setFechaSeleccionada(e.target.value)}
                    fullWidth
                    type="date"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Event sx={{ color: "primary.main" }} />
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{
                      min: moment(new Date()).format("YYYY-MM-DD"),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "white",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        "&:hover": { boxShadow: "0 4px 8px rgba(0,0,0,0.15)" },
                        "&.Mui-focused": {
                          boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
                        },
                      },
                    }}
                  />
                </Grid>

                {/* Botón Confirmar */}
                <Grid item xs={6} sm={3} md={4}>
                  <Button
                    fullWidth
                    disabled={disBtn}
                    onClick={guardarViaje}
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<Check />}
                    sx={{
                      borderRadius: 2,
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                      "&:hover": {
                        boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                      },
                      "&:disabled": {
                        backgroundColor: "grey.300",
                        color: "grey.500",
                      },
                    }}
                    title={
                      disBtn
                        ? !tieneReclamoSeleccionado
                          ? "Seleccione un reclamo"
                          : !fechaseleccionada
                            ? "Seleccione una fecha de salida"
                            : "La grúa seleccionada tiene componentes vencidos"
                        : "Confirmar viaje"
                    }
                  >
                    Confirmar Viaje
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            {/* Vencimientos*/}
            <Grid item xs={12}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <WarningAmber color="warning" />
                  {/* Vencimientos de Componentes */}
                  Vencimientos
                </Typography>
                {vencimientosGrua && vencimientosGrua.length > 0 ? (
                  <Grid container spacing={2}>
                    {vencimientosGrua.map((item) => {
                      const dias = diasRestantes(item.vencimiento);
                      const fecha = new Date(item.vencimiento);
                      const fechaFormateada = fecha.toLocaleDateString(
                        "es-AR",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        },
                      );

                      // Definir color, texto y fondo
                      let color, statusText, bgColor;
                      if (dias < 0) {
                        color = "error";
                        statusText = "Vencido";
                        bgColor = "rgba(244, 67, 54, 0.08)"; // rojo muy claro
                      } else if (dias <= 7) {
                        color = "warning";
                        statusText = "Por vencer";
                        bgColor = "rgba(255, 152, 0, 0.08)"; // naranja muy claro
                      } else {
                        color = "success";
                        statusText = "Vigente";
                        bgColor = "rgba(76, 175, 80, 0.08)"; // verde muy claro
                      }

                      return (
                        <Grid item xs={12} sm={6} md={4} key={item.id}>
                          <Card
                            elevation={2}
                            sx={{
                              borderRadius: 2,
                              bgcolor: bgColor,
                              transition: "0.2s",
                              "&:hover": { boxShadow: 4 },
                            }}
                          >
                            <CardContent sx={{ p: "16px !important" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mb: 1,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  fontWeight="600"
                                  noWrap
                                  sx={{ maxWidth: "60%" }}
                                >
                                  {item.componente}
                                </Typography>
                                <Chip
                                  label={statusText}
                                  size="small"
                                  color={color}
                                  sx={{ height: 20, fontSize: "0.7rem" }}
                                />
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  color: "text.secondary",
                                }}
                              >
                                <EventIcon
                                  sx={{
                                    fontSize: "1rem",
                                    color: `${color}.main`,
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {fechaFormateada}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    ml: "auto",
                                    fontWeight: 600,
                                    color: `${color}.main`,
                                  }}
                                >
                                  {dias < 0
                                    ? `-${Math.abs(dias)} d`
                                    : dias === 0
                                      ? "Hoy"
                                      : `${dias} d`}
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                ) : (
                  <Paper sx={{ p: 3, textAlign: "center", bgcolor: "grey.50" }}>
                    <Typography color="text.secondary">
                      No hay vencimientos registrados para esta grúa
                    </Typography>
                  </Paper>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* Tabla */}
          <Box mt={3} mb={5} ml={2} mr={2}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                ref={tableRef}
                positionActionsColumn="last"
                enableColumnResizing
                data={viajesAsignados}
                columns={columns}
                enableColumnFilters={false}
                initialState={initialState}
                state={{ rowSelection }}
                muiTableHeadCellProps={{
                  align: "left",
                  sx: {
                    fontSize: 16,
                    color: "white",
                    fontWeight: "bold",
                    backgroundColor: "#1F618D",
                    borderColor: "black",
                  },
                }}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    backgroundColor:
                      row.original.porcentaje < 20 &&
                      row.original.porcentaje !== null
                        ? "#f58c8c"
                        : "#fff",
                    color: "black",
                    borderColor: "#e0e0e0",
                    fontSize: 14,
                  },
                })}
                muiTableBodyRowProps={{
                  sx: { "&:hover": { backgroundColor: "#f5f5f5" } },
                }}
                enableToolbarInternalActions={true}
                enableRowSelection
                enableRowActions
                enableBottomToolbar={true}
                onRowSelectionChange={setRowSelection}
                renderTopToolbarCustomActions={() => (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Assignment
                      sx={{ color: "primary.main", fontSize: "1.8rem" }}
                    />
                    <Typography variant="h6" fontWeight={600}>
                      Reclamos Asignados
                    </Typography>
                  </Box>
                )}
                enableExpandAll={false}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                layoutMode="semantic"
                displayColumnDefOptions={{ "mrt-row-select": { size: 1 } }}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                enableHiding={false}
                positionExpandColumn="first"
                // renderRowActions={({ row }) => (
                //   <Tooltip title="Ver ubicación" arrow>
                //     <IconButton
                //       onClick={() => handleUbicacion(row.original)}
                //       color="primary"
                //     >
                //       <PersonPinCircleIcon />
                //     </IconButton>
                //   </Tooltip>
                // )}
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <Tooltip title="Ver ubicación" arrow>
                      <IconButton
                        onClick={() => handleUbicacion(row.original)}
                        color="primary"
                      >
                        <PersonPinCircleIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Mover a grúa" arrow>
                      <IconButton
                        onClick={() => handleAbrirMoverGrua(row.original)}
                        color="warning"
                      >
                        <SwapHoriz />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
                renderBottomToolbar={({ table }) => (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      p: 1,
                      bgcolor: "#fafafa",
                    }}
                  >
                    <MRT_TablePagination table={table} />
                  </Box>
                )}
              />
            </ThemeProvider>
          </Box>
        </>
      )}

      {/* Modales y notificaciones (sin cambios) */}
      {modalVencimientos ? (
        <ModalVencimientos open={setmodalVencimientos} />
      ) : null}
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleClose}
          severity={notificacion.severity}
        />
      ) : null}
      {modalEdit ? (
        <ModalEditar
          open={modalEdit}
          datos={datos}
          setOpen={setmodalEdit}
          actualizar={obtenerViajesAsignados}
        />
      ) : null}
      {openMapa ? (
        <Dialog
          open={openMapa}
          onClose={() => setOpenMapa(false)}
          maxWidth="md"
          fullWidth
          sx={{
            "& .MuiPaper-root": {
              borderRadius: 4,
            },
          }}
        >
          <DialogContent>
            <MapaRepartos
              latitud={datos.latitud}
              longitud={datos.longitud}
              direccion_entrega={datos.direccion_entrega}
              handleClose={() => setOpenMapa(false)}
            />
          </DialogContent>
        </Dialog>
      ) : null}

      {/* Diálogo de confirmación para viaje existente */}
      {openDialogConfirmacion && datosConfirmacion && (
        <Dialog
          open={openDialogConfirmacion}
          onClose={handleCancelarAgregarViaje}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              bgcolor: "warning.light",
              color: "warning.contrastText",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <WarningAmber sx={{ fontSize: "1.5rem" }} />
            Viaje Existente Encontrado
          </DialogTitle>
          <DialogContent sx={{ mt: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <LocalShipping color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6" color="primary">
                Grúa: {datosConfirmacion.gruaPatente}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Event color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6" color="primary">
                Fecha:{" "}
                {moment(datosConfirmacion.fechaseleccionada).format(
                  "DD/MM/YYYY",
                )}
              </Typography>
            </Box>
            <Alert
              severity="warning"
              sx={{ mb: 3 }}
              icon={<Info sx={{ fontSize: "1.2rem" }} />}
            >
              <Typography variant="body1" fontWeight="bold">
                Ya existe un grupo de viajes para esta grúa en la fecha
                seleccionada.
              </Typography>
            </Alert>
            <Box
              sx={{
                bgcolor: "grey.50",
                p: 2,
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Typography variant="body1" paragraph>
                <strong>
                  ¿Desea agregar {datosConfirmacion.cantidadReclamos} reclamo(s)
                  seleccionado(s) al viaje existente?
                </strong>
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                • Se mantendrán agrupados para el mismo día y vehículo
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "space-between",
              px: 3,
              pb: 2,
            }}
          >
            <Button
              onClick={handleCancelarAgregarViaje}
              variant="outlined"
              color="inherit"
              startIcon={<Close />}
              sx={{ mr: 1 }}
            >
              Volver
            </Button>
            <Button
              onClick={handleConfirmarAgregarViaje}
              variant="contained"
              color="primary"
              startIcon={<Check />}
              autoFocus
            >
              Agregar al Viaje Existente
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Modal: Mover a Grúa */}
      {openModalMoverGrua && reclamoParaMover && (
        <Dialog
          open={openModalMoverGrua}
          onClose={() => setOpenModalMoverGrua(false)}
          maxWidth="xs"
          fullWidth
          sx={{ "& .MuiPaper-root": { borderRadius: 3 } }}
        >
          <DialogTitle
            sx={{
              bgcolor: "warning.light",
              color: "warning.contrastText",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <SwapHoriz sx={{ fontSize: "1.5rem" }} />
            Mover Reclamo a otra grúa
          </DialogTitle>

          <DialogContent sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Reclamo <strong>#{reclamoParaMover.id_reclamo}</strong> —{" "}
              {reclamoParaMover.cliente_razon_social}
            </Typography>

            <Autocomplete
              options={gruas || []}
              value={gruaDestino}
              onChange={(_, newValue) => setGruaDestino(newValue)}
              getOptionLabel={(option) => option.patente ?? ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccioná la grúa destino"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <LocalShipping
                          sx={{
                            color: "primary.main",
                            mr: 1,
                            fontSize: "1.3rem",
                          }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  <LocalShipping sx={{ color: "primary.main", mr: 1 }} />
                  <Typography variant="body2">
                    {option.patente}
                    {option.chofer ? ` — ${option.chofer}` : ""}
                  </Typography>
                </Box>
              )}
            />
          </DialogContent>

          <DialogActions
            sx={{
              px: 3,
              pb: 2,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              onClick={() => setOpenModalMoverGrua(false)}
              // variant="outlined"
              variant="contained"
              color="error"
              startIcon={<Close />}
            >
              Volver
            </Button>
            <Button
              onClick={handleConfirmarMoverGrua}
              variant="contained"
              color="primary"
              startIcon={<Check />}
              disabled={!gruaDestino}
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Snackbar de notificación */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}
